<template>
  <div class="statistics-page">
    <div class="flex-box">
      <div class="shortcuts">
        <el-button 
          :type="activeShortcut.code===item.code?'primary':''"
          v-for="item in shortcutList"
          :key="item.code"
          @click="shortcutClick(item)"
        >{{item.title}}</el-button>
      </div>
      <div style="width:100px"></div>
      <div class="month-picker flex-box ju-c al-c">
        <el-date-picker
          v-model="dateRange"
          @change="handleDataChange"
          value-format="yyyy-MM-dd"
          type="daterange"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </div>
    </div>
    <div class="flex-box al-c mt20 mb20">
      <div @click="breadcrumbChange('question-views')" :class="`cu-p breadcrumb ${activeBreadcrumb==='question-views'?'active':''}`">问题查看top5</div>
      <div class="ml10 mr10">/</div>
      <!-- <div @click="breadcrumbChange('missing')" :class="`cu-p breadcrumb ${activeBreadcrumb==='missing'?'active':''}`">未录入问题top5</div>
      <div class="ml10 mr10">/</div> -->
      <div @click="breadcrumbChange('question-upVote')" :class="`cu-p breadcrumb ${activeBreadcrumb==='question-upVote'?'active':''}`">点赞最多问题top5</div>
      <div class="ml10 mr10">/</div>
      <div @click="breadcrumbChange('question-downVote')" :class="`cu-p breadcrumb ${activeBreadcrumb==='question-downVote'?'active':''}`">踩最多问题top5</div>
    </div>
    <div class="bor pt20 pb20 pl20 pr20 flex-box flex-col ju-c" style="min-height:226px" v-loading="loading">
      <div class="flex-box al-c pb20" v-for="item in list" :key="item.queId">
        <div style="width:250px" class="tx-r">{{item.queTitle}}</div>
        <div class="progress ml10 mr20">
          <el-progress :percentage="handleTopProgress(item.queCount)" color="#4494F4" :show-text="false"></el-progress>
        </div>
        <div>{{item.queCount}}次</div>
      </div>
      <div class="w100 tx-c grey" v-if="!list.length">暂无数据</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {questionQueryCntVoList} from '@/api/management/QAHelper'


export default {
  name: "statistics",
  data() {
    return {
      shortcutList: [
        {code: 1, title: '今日'},
        {code: 2, title: '最近7天'},
        {code: 3, title: '最近30天'},
        {code: 4, title: '最近一年'},
        {code: 5, title: '去年'},
        {code: 6, title: '前年'},
      ],
      activeShortcut: {code: 2, title: '最近7天'},
      shortcutDateRange: [moment().subtract('days', 6).format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')],
      dateRange: [],
      activeBreadcrumb: 'question-views',
      statisticData: [],
      list: [],
      loading: false,
    };
  },
  components: {
  },
  computed: {
  },
  watch: {
    activeShortcut(val){
      if(val.code){
        this.dateRange = [];
        switch (val.code) {
          case 1:
            this.shortcutDateRange = [moment().format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')]
            break;
          case 2:
            this.shortcutDateRange = [moment().subtract('days', 6).format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')];
            break;
          case 3:
            this.shortcutDateRange = [moment().subtract('days', 29).format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')];
            break;
          case 4:
            this.shortcutDateRange = [moment().subtract('days', 365).format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')];
            break;
          case 5:
            this.shortcutDateRange = [moment().year(moment().year() - 1).startOf('year').format('YYYY-MM-DD'),moment().year(moment().year() - 1).endOf('year').format('YYYY-MM-DD')];
            break;
          case 6:
            this.shortcutDateRange = [moment().year(moment().year() - 2).startOf('year').format('YYYY-MM-DD'),moment().year(moment().year() - 2).endOf('year').format('YYYY-MM-DD')];
            break;
          default:
            this.shortcutDateRange = [];
            break;
        }
        this.handleDataChange();
      }else {
        this.shortcutDateRange = [];
      }
    },
    dateRange(val){
      if(!val){
        this.activeShortcut = {code: 2, title: '最近7天'};
        return
      }
      if(val.length>0){
        this.activeShortcut = {};
      }
    },
    statisticData(val){
      this.handleList()
    },
    activeBreadcrumb(val){
      this.handleList()
    }
  },
  created() {
    this.initContent()
  },
  methods: {
    handleTopProgress(num){
      if(this.list.length>0){
        return num/this.list[0].queCount * 100
      }
      return 0;
    },
    handleList(){
      this.list = ((this.statisticData.find(item => item.queAct === this.activeBreadcrumb) || {}).questionCnts) || []
    },
    shortcutClick(item){
      this.activeShortcut = item;
    },
    handleDataChange(){
      this.initContent();
    },
    initContent(){
      let obj = {
        len: 5,
      }
      if(this.shortcutDateRange.length){
        obj.begin_date = this.shortcutDateRange[0];
        obj.end_date = this.shortcutDateRange[1];
      }else if(this.dateRange){
        obj.begin_date = this.dateRange[0]
        obj.end_date = this.dateRange[1]
      }
      this.loading = true
      questionQueryCntVoList(obj)
      .then(({data}) => {
        if(data.code == 0){
          this.statisticData = data.data || [];
        }else {
          this.$message.error(data.msg)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    breadcrumbChange(type){
      this.activeBreadcrumb = type;
    }
  }
};
</script>

<style lang="less" scoped>
.statistics-page {
  .breadcrumb {
    &:hover,&.active {
      color: #409eff;
    }
  }
  .progress {
    width: 500px;
  }
}
</style>